export const idCostTypeMapper = {
  'Biaya Perjalanan': 'costManagement.type.travelCost',
  'Biaya Kendaraan': 'costManagement.type.vehicleCost',
  'Biaya Lainnya': 'costManagement.type.otherCost',
}

export const idCostStatusMapper = {
  Draf: 'costManagement.status.draft',
  Dikonfirmasi: 'costManagement.status.confirmed',
}

export const idFleetTaskStatusMapper = {
  Dijadwalkan: 'fleetTask.status.scheduled',
  Perjalanan: 'fleetTask.status.started',
  Selesai: 'fleetTask.status.ended',
}
